import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import  store  from './store/store.js'
import './registerServiceWorker'


//COMPONENTS
import Loader from '@/components/general/Loader.vue';
Vue.component('loader', Loader);

import Toasted from 'vue-toasted';
Vue.use(Toasted)

import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
Vue.use(VuejsDialog);

//DATE
import Date from '@/components/general/Date.vue';
Vue.component('convert-date', Date);

import DaysPassed from '@/components/general/DaysPassed.vue';
Vue.component('days-passed', DaysPassed);

//LAYOUTS
import Blank from './layouts/Blank.vue'
Vue.component('blank-layout', Blank);

import Dashboard from './layouts/Dashboard.vue'
Vue.component('dashboard-layout', Dashboard);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
